import React, { FC } from 'react';
import Img from 'src/common/components/Img';
import SnoozeToggle from 'src/admin/common/components/SnoozeModal/SnoozeToggle';
import styles from './SnoozeIndividualListing.module.scss';

export type SnoozeIndividualListingProps = {
  headline: string;
  imageSrc: string;
  checked: boolean;
  handleToggle: () => void;
};

const SnoozeIndividualListing: FC<SnoozeIndividualListingProps> = ({
  headline,
  imageSrc,
  checked,
  handleToggle,
}) => (
  <SnoozeToggle
    checked={checked}
    handleToggle={handleToggle}
    variant="individual"
  >
    <div className={styles.title}>
      <Img
        withPlaceholder
        src={imageSrc}
        alt={headline}
        width={40}
        height={40}
        className={styles.img}
      />
      {headline}
    </div>
  </SnoozeToggle>
);

export default SnoozeIndividualListing;
